document.addEventListener('DOMContentLoaded', function () {
  // desktop only
  if (window.innerWidth < 750) return;

  const images = document.querySelectorAll(
    '.product-media-container--image .product-media__image'
  );

  images.forEach(function (img) {
    const container = img.closest('.product-media-container--image');
    if (!container) return;

    function updateZoomPosition(event) {
      const rect = container.getBoundingClientRect();
      const x = ((event.clientX - rect.left) / rect.width) * 100;
      const y = ((event.clientY - rect.top) / rect.height) * 100;

      container.style.setProperty('--zoom-x', x + '%');
      container.style.setProperty('--zoom-y', y + '%');
    }

    // Click to toggle zoom
    container.addEventListener('click', function (event) {
      event.preventDefault();

      const isZoomed = container.classList.toggle('is-zoomed');
      if (isZoomed) updateZoomPosition(event);
    });

    // Mousemove to pan zoom
    container.addEventListener('mousemove', function (event) {
      if (!container.classList.contains('is-zoomed')) return;
      updateZoomPosition(event);
    });
  });
});
